import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ModeProvider } from "@/context/ModeContext";
import Home from "@/pages/Home";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import AdminLayout from "@/pages/admin/AdminLayout";
import Overview from "@/pages/admin/Overview";
import Appointments from "@/pages/admin/Appointments";
import Billing from "@/pages/admin/Billing";
import Inventory from "@/pages/admin/Inventory";
import Reports from "@/pages/admin/Reports";
import Customers from "@/pages/admin/Customers";
import Staff from "@/pages/admin/Staff";
import ServicesAdmin from "@/pages/admin/ServicesAdmin";
import Loyalty from "@/pages/admin/Loyalty";
import Finance from "@/pages/admin/Finance";
import Settings from "@/pages/admin/Settings";
import StaffDay from "@/pages/admin/StaffDay";

const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F4F5F4]">
        <div className="text-[#5C6A63] text-sm" data-testid="auth-loading">Loading…</div>
      </div>
    );
  if (user === false) return <Navigate to="/admin/login" replace />;
  return children;
};

function AppRouter() {
  const location = useLocation();
  // Handle Google OAuth return BEFORE any protected-route auth checks
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/admin/login" element={<Login />} />
      <Route path="/admin" element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
        <Route index element={<Overview />} />
        <Route path="appointments" element={<Appointments />} />
        <Route path="billing" element={<Billing />} />
        <Route path="inventory" element={<Inventory />} />
        <Route path="loyalty" element={<Loyalty />} />
        <Route path="finance" element={<Finance />} />
        <Route path="reports" element={<Reports />} />
        <Route path="customers" element={<Customers />} />
        <Route path="staff" element={<Staff />} />
        <Route path="services" element={<ServicesAdmin />} />
        <Route path="settings" element={<Settings />} />
        <Route path="staff-day" element={<StaffDay />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <ModeProvider>
          <BrowserRouter>
            <AppRouter />
          </BrowserRouter>
          <Toaster position="top-right" richColors />
        </ModeProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
